import { jsx, css } from '@emotion/react';
import _ from 'lodash';

import MarqueeFeatures from './oc-marquee-features';
import Section from './oc-section';
import Card from '../oc-card';
import Icon from '../oc-icon';
import RichText from '../oc-rich-text';
import getExtension from '../utilities/file-extension';

const styles = css`
  margin-top: 0 !important;

  .key-attributes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    .oc-card {
      width: 25%;
      border-right: 1px solid #959595;

      img {
        width: 92px;
        height: 92px;
      }

      .media,
      .text {
        text-align: center;
      }

      &:nth-of-type(4n) {
        border-right: none;
      }

      &:last-of-type {
        border-right: none;
      }

      @media (max-width: 1199px) {
        img {
          width: 75px;
          height: 75px;
        }
      }

      @media (max-width: 767px) {
        width: 50%;
        &:nth-of-type(2n) {
          border-right: none;
        }
      }
    }
  }
`;

const defaultIconUrl =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1629751182/composites/icons/icon-quick-resolution.png';

const PerformanceAttributes = ({ heading, anchor, keyFeatures, bulletPoints, withMedia, className }) => (
  <div className="bg-full-bleed bg-shaded">
    <Section anchor={anchor} className={className} css={styles}>
      <h2>
        <RichText content={heading} />
      </h2>
      <div className="key-attributes">
        {keyFeatures.map((feature, i) => (
          <Card
            alt={_.get(feature, 'images.icon.url') ? `${feature.name} Icon` : 'Checkmark on Clipboard Icon'}
            img={_.get(feature, 'images.icon.url') || defaultIconUrl}
            key={i}
          >
            <h3 className="h4">
              <RichText content={feature.name} />
            </h3>
          </Card>
        ))}
      </div>
      <MarqueeFeatures bulletPoints={bulletPoints} withMedia={withMedia} hasMainItems={keyFeatures.length} />
    </Section>
  </div>
);

export default PerformanceAttributes;
